import { PacketValueSerialType } from "../enum/PacketValueSerialType";
import NetworkBehavior from "../lib/NetworkBehavior";
import { Time } from "../lib/Time";
import { Physics } from "../math/Physics";
import Vector2 from "../math/Vector2";
import Color from "../util/Color";
import Asteroid from "./Asteroid";
import Player from "./Player";

export default class Bullet extends NetworkBehavior {
    velocity = Vector2.zero;
    born = Time.time;
    team: "red"|"blue"|undefined;
    damage: number = 1;
    ownerName = "";
    ownerId = "";
    isExplosive = false;
    explosiveDamage = 1;
    splashRadius = 64;

    isEMP = false;

    get timeAlive() {return Time.time - this.born;}

    get owner() {
        return this.engine.GetGameObjectsBehaviors<Player>(Player).filter(v => v.gameObject.id === this.gameObject.id)[0];
    }

    splashDamage()  {
        if (!this.isOwner || !this.isExplosive) return;

        const validPlayers = this.engine.GetGameObjectsBehaviors<Player>(Player).filter(
            v => !v.isDead && v.team && v.team !== this.team
        );

        for (const player of validPlayers) {
            if (Physics.CircleCircleCollision({
                position: this.transform.position,
                radius: 4
            }, {
                position: player.transform.position,
                radius: player.size
            }) !== false) {
                this.engine.createExplosion({
                    size: this.isExplosive ? this.splashRadius : 4,
                    position: this.transform.position,
                    color: new Color(255, 255, 255)
                });

                this.engine.sendDamagePacket(player, this.damage);
            }
        }
    }

    Die() {
        if (this.isOwner) {
            this.splashDamage();
            this.engine.sendRemovePacket(this.gameObject);
        }
        this.engine.createExplosionForAll({
            size: this.isExplosive ? this.splashRadius : 4,
            position: this.transform.position,
            color: new Color(255, 255, 255)
        });
        this.engine.RemoveGameObject(this.gameObject);
    }

    Update(): void {
        if (this.timeAlive >= 5) {
            this.engine.RemoveGameObject(this.gameObject);
            return;
        }

        this.transform.rotation = Vector2.fromRadians(this.velocity.angle);

        this.transform.position = this.transform.position.add(this.velocity.scale(Time.deltaTime));

        for (const asteroid of this.engine.GetGameObjectsBehaviors<Asteroid>(Asteroid)) {
            if (Physics.CircleShapeCollision({
                position: this.transform.position,
                radius: 4
            }, asteroid.pointVectors.map(v => asteroid.transform.position.add(v))) !== false) {
                this.engine.createExplosion({
                    size: this.isExplosive ? this.splashRadius : 4,
                    position: this.transform.position,
                    color: new Color(255, 255, 255)
                });
                this.Die();
                break;
            }
        }

        if (!this.isOwner) return;

        const validPlayers = this.engine.GetGameObjectsBehaviors<Player>(Player).filter(
            v => !v.isDead && v.team && v.team !== this.team
        );

        for (const player of validPlayers) {
            if (Physics.CircleCircleCollision({
                position: this.transform.position,
                radius: 4
            }, {
                position: player.transform.position,
                radius: player.size
            }) !== false) {
                this.engine.createExplosion({
                    size: this.isExplosive ? this.splashRadius : 4,
                    position: this.transform.position,
                    color: new Color(255, 255, 255)
                });

                this.engine.sendDamagePacket(player, this.damage);

                if (this.isEMP) {
                    this.engine.sendUpdatePacket(player, "PLAYER", [
                        {
                            key: "isDisabled",
                            value: true,
                            type: PacketValueSerialType.Bool
                        }
                    ]);
                }

                this.Die();
                break;
            }
        }

        
    }

    Draw(): void {
        this.ctx.lineWidth = 2;
        this.ctx.strokeStyle = this.engine.clientPlayer?.team === this.team ? '#55ff55' : '#ff5555';
        this.engine.Line(this.transform.position.add(this.transform.forward.scale(2)), this.transform.position.add(this.transform.back.scale(2)));
    }

    DrawGizmos(): void {
        this.engine.drawTextsWorldPosition([`owner: ${this.isOwner}`], this.transform.position.add(Vector2.one.scale(4)), {color: this.engine.viewport.fColor});
    }

}